import React, { CSSProperties, useRef } from "react";
import Spinner from "../../../components/Icons/Spinner";
import styles from "./styles.module.css";
const Button = ({
    title,
    loading,
    onClick,
    style = {},
    className,
    inheritLoadingColor,
    spinnerSize = 36,
    id,
    disabledCta = false,
    buttonTypeButton = "",
    onMouseEnter,
    onMouseLeave,
}: {
    title: string | JSX.Element | (string | JSX.Element)[];
    loading?: boolean;
    onClick: React.MouseEventHandler<HTMLButtonElement>;
    style: CSSProperties;
    className?: string;
    spinnerSize?: number | string;
    inheritLoadingColor?: boolean;
    id?: string;
    disabledCta?: boolean;
    buttonTypeButton?: string;
    onMouseEnter?: React.MouseEventHandler<HTMLButtonElement>;
    onMouseLeave?: React.MouseEventHandler<HTMLButtonElement>;
}) => {
    const ref = useRef(null);

    return (
        <button
            className={className ? className : styles.button}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
            style={{
                ...style,
                // height: "max-content",
                // padding: "4px",
                // minHeight: "36px",
                ...(disabledCta && { cursor: "not-allowed", opacity: 0.6 }),
            }}
            ref={ref}
            disabled={loading || disabledCta}
            id={id || ""}
            {...(buttonTypeButton ? { type: "button" } : {})}
        >
            {loading ? (
                window.isKefiAdmin ? (
                    <Spinner
                        color={
                            inheritLoadingColor && ref?.current
                                ? getComputedStyle(ref?.current)?.color?.toString()
                                : "white"
                        }
                        size={spinnerSize as number}
                    />
                ) : (
                    <div className={styles.loader}>
                        <span></span>
                    </div>
                )
            ) : (
                title
            )}
        </button>
    );
};

export default Button;
